import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { formatLatency } from "../../utils/analyticsLatency";
import { toolLabel } from "../../utils/analyticsTools";
import DataTable from "../charts/DataTable";
import { formatCount, formatPercent } from "../charts/format";
import InlineBar from "./InlineBar";
import Section from "./Section";

const secondary = { color: "var(--color-text-secondary)" };
const card = { borderColor: "var(--color-border)", backgroundColor: "var(--color-surface)" };

// As ferramentas usadas (D11 e D13 do plano do RPAA-286): uma linha por ferramenta, pelas chamadas, com as
// que falharam e o tempo tipico (a mediana). Sem traducao o nome mostra-se como veio. A mediana e `null`
// numa ferramenta sem tempo medido, e o formatLatency diz-o.
const ToolsUsed = ({ tools, ordersVariant }) => {
  const { translate, language } = useLanguage();
  const calls = tools.reduce((sum, tool) => sum + tool.calls, 0);
  const failed = tools.reduce((sum, tool) => sum + tool.failed, 0);
  const max = Math.max(0, ...tools.map((tool) => tool.calls));
  let note = null;
  if (calls === 1) note = translate(failed === 1 ? "analyticsToolsLeadOneFailed" : "analyticsToolsLeadOne");
  else if (calls > 1 && failed === 0) note = translate("analyticsToolsLeadNoFailures", { calls: formatCount(calls, language) });
  else if (calls > 1) note = translate("analyticsToolsLead", { calls: formatCount(calls, language), share: formatPercent((100 * failed) / calls, language) });
  return (
    <Section title={translate("analyticsToolsUsed")} note={note} info={translate("analyticsToolsNote")} className="space-y-2">
      {tools.length === 0 ? (
        <p className="text-sm" style={secondary}>
          {translate("analyticsNoToolCalls")}
        </p>
      ) : (
        <div className="rounded-xl border p-4" style={card}>
          <DataTable
            caption={translate("analyticsToolsUsed")}
            columns={[
              { key: "tool", label: translate("analyticsTool") },
              { key: "calls", label: translate("analyticsCallsColumn"), numeric: true },
              { key: "failed", label: translate("analyticsFailedColumn"), numeric: true },
              { key: "time", label: translate("analyticsTypicalTime"), numeric: true },
            ]}
            rows={tools.map((tool) => ({
              key: tool.name,
              tool: toolLabel(tool.name, ordersVariant, translate),
              calls: <InlineBar value={tool.calls} max={max} text={formatCount(tool.calls, language)} />,
              failed: tool.failed > 0 ? `${formatCount(tool.failed, language)} (${formatPercent(tool.failed_pct, language)})` : formatCount(0, language),
              time: formatLatency(tool.median_ms ?? null, language, translate),
            }))}
          />
        </div>
      )}
    </Section>
  );
};

export default ToolsUsed;
